export {
    prepareProductForInstagramPost,
    prepareProductInstagramPost,
};

const _ = require("lodash");
const Promise = require("bluebird");

const prepareProductForInstagramPost = async (shopifyProductList) => {
    const instagramPostList = [];
    _.forEach(shopifyProductList, (shopifyProduct) => {
        if (shopifyProduct?.settings?.imagesUploaded) {
            instagramPostList.push(prepareProductInstagramPost(shopifyProduct));
        }
    });

    return instagramPostList;
};

const prepareProductInstagramPost = (shopifyProduct) => {
    const instagramPost: any = {};
    instagramPost.caption = shopifyProduct?.settings?.instagramText;
    instagramPost.imageFileUrlList = [];

    _.forEach(shopifyProduct.images, (productImage) => {
        if (productImage.instagram && productImage.downloadUrl) {
            instagramPost.imageFileUrlList.push(productImage.downloadUrl);
        }
    });

    if (!_.isEmpty(instagramPost.imageFileUrlList)) {
        instagramPost.imageFileUrlList = (_.chunk(instagramPost.imageFileUrlList, 10))[0];
    }

    return instagramPost;
};
